export const ROUTES = {
    HOME: '',
    DETAIL: '/detail/:id'
};
